import { APIPaths } from "@/apis/api-config";

import BaseApi from "../base-api";

export class EventApi extends BaseApi {
  async getEventById(
    parameters: APIPaths["/operator-dash/event/{id}"]["get"]["parameters"]["path"],
  ): Promise<APIPaths["/operator-dash/event/{id}"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get(`/operator-dash/event/${parameters.id}`)).data;
  }
  async getEventList(
    parameters: APIPaths["/operator-dash/event/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/operator-dash/event/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/operator-dash/event/list", { params: parameters })).data;
  }
  async postEventNew(
    requestBody: APIPaths["/operator-dash/event/new"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/operator-dash/event/new"]["post"]["responses"]["201"]["content"]["application/json"]> {
    return (await this.post("/operator-dash/event/new", requestBody)).data;
  }
  async patchEventById(
    parameters: APIPaths["/operator-dash/event/{id}"]["patch"]["parameters"]["path"],
    requestBody: APIPaths["/operator-dash/event/{id}"]["patch"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/operator-dash/event/{id}"]["patch"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.patch(`/operator-dash/event/${parameters.id}`, requestBody)).data;
  }
  async deleteEventById(
    parameters: APIPaths["/operator-dash/event/{id}"]["delete"]["parameters"]["path"],
  ): Promise<APIPaths["/operator-dash/event/{id}"]["delete"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.delete(`/operator-dash/event/${parameters.id}`)).data;
  }
}
